"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _validEmail = _interopRequireDefault(require("../../utils/validEmail"));
var _FormItem = _interopRequireDefault(require("./FormItem"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
var _excluded = ["label", "labelPosition", "type", "onlySuccess", "validatorClassName", "labelClassName", "required"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'transition', 'text']),
  className = _CssClassNames.className;
var FormGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormGroup, _PureComponent);
  var _super = _createSuper(FormGroup);
  function FormGroup() {
    var _this;
    _classCallCheck(this, FormGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      error: false,
      success: false,
      msg: null,
      id: "fm".concat(Math.random().toString(36).substring(2, 15))
    });
    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function (evt) {
      var type = _this.props.type;
      _this.setState({
        value: type === 'checkbox' || type === 'radio' ? evt.target.checked : evt.target.value,
        error: false,
        success: false
      });
      if (_this.props.onChange) {
        _this.props.onChange(evt);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setSuccess", function (msg) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3500;
      _this.setState({
        success: true,
        msg: msg
      });
      setTimeout(function () {
        _this.setState({
          success: false,
          msg: null,
          value: ''
        });
      }, duration);
    });
    _defineProperty(_assertThisInitialized(_this), "clearError", function () {
      _this.setState({
        error: false,
        msg: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setError", function (msg) {
      _this.setState({
        error: true,
        msg: msg
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function (e) {
      e.preventDefault();
      _this.setState({
        error: false,
        success: false,
        msg: null
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isFocused", function () {
      return typeof window !== 'undefined' && window.document.activeElement === _this.refItem;
    });
    _defineProperty(_assertThisInitialized(_this), "switchCheckboxOnPressSpace", function (e) {
      if (e.keyCode === 32 && _this.refItem) {
        e.preventDefault();
        var newChecked = _this.refItem.checked ? false : true;
        _this.refItem.checked = newChecked;
        _this.updateInputValue({
          target: {
            checked: newChecked
          }
        });
      }
    });
    return _this;
  }
  _createClass(FormGroup, [{
    key: "setValue",
    value: function setValue(value) {
      if (this.refItem) {
        if (this.props.type === 'checkbox' || this.props.type === 'radio') {
          this.refItem.checked = value;
        } else {
          this.refItem.value = value;
        }
      }
      this.setState({
        value: value,
        error: false,
        success: false
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this$props = this.props,
        _this$props$type = _this$props.type,
        type = _this$props$type === void 0 ? 'text' : _this$props$type,
        _this$props$defaultMe = _this$props.defaultMessages,
        defaultMessages = _this$props$defaultMe === void 0 ? {} : _this$props$defaultMe,
        required = _this$props.required;
      if (!this.state.value && required) {
        this.setState({
          error: true,
          msg: defaultMessages.required || 'This field is mandatory'
        });
        return false;
      }
      if (type === 'email') {
        var validate = (0, _validEmail["default"])(this.state.value);
        if (!validate) {
          this.setState({
            error: true,
            msg: defaultMessages.email || '* Please provide a valid email'
          });
        }
        return validate;
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        label = _this$props2.label,
        _this$props2$labelPos = _this$props2.labelPosition,
        labelPosition = _this$props2$labelPos === void 0 ? 'before' : _this$props2$labelPos,
        _this$props2$type = _this$props2.type,
        type = _this$props2$type === void 0 ? 'text' : _this$props2$type,
        _this$props2$onlySucc = _this$props2.onlySuccess,
        onlySuccess = _this$props2$onlySucc === void 0 ? false : _this$props2$onlySucc,
        _this$props2$validato = _this$props2.validatorClassName,
        validatorClassName = _this$props2$validato === void 0 ? '' : _this$props2$validato,
        _this$props2$labelCla = _this$props2.labelClassName,
        labelClassName = _this$props2$labelCla === void 0 ? '' : _this$props2$labelCla,
        _this$props2$required = _this$props2.required,
        required = _this$props2$required === void 0 ? false : _this$props2$required,
        props = _objectWithoutProperties(_this$props2, _excluded);
      var _this$state = this.state,
        error = _this$state.error,
        id = _this$state.id,
        success = _this$state.success,
        msg = _this$state.msg;
      var isCheckbox = type === 'checkbox' || type === 'radio';
      var isCustomCheckbox = isCheckbox && labelPosition !== 'before';
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, success && msg && onlySuccess ? /*#__PURE__*/_react["default"].createElement("div", className("valid-feedback valid-msg"), /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: msg
        }
      })) : /*#__PURE__*/_react["default"].createElement("div", className("".concat(isCheckbox ? isCustomCheckbox ? "custom-control custom-".concat(type === 'radio' ? 'radio' : 'checkbox') : 'form-check' : 'form-group', " ").concat(this.props.className ? this.props.className : '')), label && labelPosition === 'before' && /*#__PURE__*/_react["default"].createElement("label", _extends({
        htmlFor: id
      }, className("".concat(isCheckbox ? 'form-check-label' : '', " \n                                    ").concat(labelClassName ? labelClassName : '')), {
        dangerouslySetInnerHTML: {
          __html: label
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormItem["default"], _extends({
        ref: function ref(el) {
          return _this2.refItem = el;
        }
      }, props, {
        label: label,
        type: type
      }, this.state, {
        onChange: this.updateInputValue,
        onFocus: this.handleOnFocus,
        required: isCustomCheckbox ? false : required,
        isCustomCheckbox: isCustomCheckbox
      })), label && labelPosition !== 'before' && /*#__PURE__*/_react["default"].createElement("label", _extends({
        htmlFor: id
      }, className("".concat(isCheckbox ? isCustomCheckbox ? 'custom-control-label' : 'form-check-label' : '', " ").concat(labelClassName ? labelClassName : '')), isCustomCheckbox && {
        tabIndex: 0
      }, {
        onKeyDown: isCustomCheckbox ? this.switchCheckboxOnPressSpace : null,
        dangerouslySetInnerHTML: {
          __html: label
        }
      })), error && msg && /*#__PURE__*/_react["default"].createElement("div", className("invalid-feedback ".concat(validatorClassName ? validatorClassName : '')), /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: msg
        }
      })), success && msg && !onlySuccess && /*#__PURE__*/_react["default"].createElement("div", className("valid-feedback ".concat(validatorClassName ? validatorClassName : '')), /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: msg
        }
      }))));
    }
  }]);
  return FormGroup;
}(_react.PureComponent);
exports.FormGroup = FormGroup;